import { BsFillPatchCheckFill } from 'react-icons/bs';
import React, { useContext } from 'react';
// import { ThemeContext } from '../../context/ThemeContext';

/**
 * "Chidi O." when we have both names, "Chidi" when we only have one, and
 * the email when we have neither. A talent registered by an admin has not
 * filled anything in yet, so this has to cope with every field missing.
 */
function displayName(data) {
  if (!data) {
    return '—';
  }

  if (data.firstName && data.lastName) {
    return data.firstName + ' ' + data.lastName.slice(0, 1) + '.';
  }
  if (data.firstName) {
    return data.firstName;
  }
  if (data.lastName) {
    return data.lastName;
  }
  if (data.email) {
    return data.email;
  }
  return '—';
}

const TalentAvatar = ({ size, verified, data, edit }) => {
  const { theme } = 'light' // useContext(ThemeContext);

  return (
    <div className='flex flex-row items-center w-fit space-x-3'>
      <div className='relative'>
        <div className={'relative w-20 h-20 md:w-32 md:h-32 rounded-full border border-gray-300 justify-center items-center overflow-hidden'}>
          <img
            src={data?.photo}
            className='w-full h-full'
            alt={data?.firstName}
          />
        </div>
        {verified && (
          <BsFillPatchCheckFill
            className='absolute right-1 top-[80%]'
            size={size || 14}
            color='#F58800'
          />
        )}
      </div>
      <div>
        <p
          className={`text-left capitalize lg:text-[1.75rem] text-lg leading-8 font-semibold ${theme === 'dark' ? 'text-white' : 'text-brand-navy'
            }`}
        >
          {/* A talent who has not filled in their names yet rendered as
              "undefined undefined." — string concatenation on absent
              fields. Their email is the honest fallback. */}
          {displayName(data)}
        </p>
        <p
          className={`text-sm text-left font-semibold text-muted-foreground whitespace-nowrap`}
        >
          {data?.phone}
        </p>
        <p
          className={`text-sm text-left font-semibold text-muted-foreground whitespace-nowrap`}
        >
          {data?.email}
        </p>
        <p
          className={`text-sm capitalize text-left font-semibold text-muted-foreground whitespace-nowrap`}
        >
          {/* Their own title, with the library role name as the API's
              fallback for talents who never set one. */}
          {data?.display_title || data?.primaryStack}
        </p>
      </div>
    </div>
  );
};

export default TalentAvatar;
